import React from 'react';
import PropTypes from 'prop-types';
import { Card as MuiCard, CardHeader, CardContent, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import EmptyState from './EmptyState';

/**
 * Simple material table inside a card wrapper. Accepts columns definition and rows array.
 */
export default function TableCard ({ title, columns, rows, maxHeight = 420, dense = false, action }) {
  return (
    <MuiCard elevation={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader title={title} action={action} sx={{ pb: 0 }} />
      <CardContent sx={{ flexGrow: 1, overflowX: 'auto' }}>
        <Table size={dense ? 'small' : 'medium'} stickyHeader sx={{ minWidth: 600, maxHeight }}>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.id} align={col.align || 'left'}>{col.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center" sx={{ p: 0 }}>
                  <EmptyState />
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, idx) => (
                <TableRow key={idx} hover>
                  {columns.map((col) => (
                    <TableCell key={col.id} align={col.align || 'left'}>
                      {typeof col.render === 'function' ? col.render(row[col.id], row) : row[col.id]}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </MuiCard>
  );
}

TableCard.propTypes = {
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.oneOf(['left', 'right', 'center']),
      render: PropTypes.func,
    })
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  maxHeight: PropTypes.number,
  dense: PropTypes.bool,
  action: PropTypes.node,
};
